import { Switch } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"

const ChaveDisponibilidade = withStyles({
    switchBase: {
        color: "#DC4C64",
        "&$checked": {
            color: "#14A44D",
        },
        "&$checked + $track": {
            backgroundColor: "#14A44D",
            opacity: 1,
        },
    },
    checked: {},
    track: {
        backgroundColor: "#DC4C64",
        opacity: 1,
    },
})(Switch)

function DisponibilidadeSwitch({
    produto,
    disponivel,
    handleChangeDisponibilidadeProduto,
    handleChangeDisponibilidadeOpcao,
}) {
    return (
        <ChaveDisponibilidade
            checked={!!disponivel}
            onChange={
                produto ? handleChangeDisponibilidadeProduto : handleChangeDisponibilidadeOpcao
            }
            inputProps={{ "aria-label": "Disponibilidade" }}
        />
    )
}

export default DisponibilidadeSwitch
